// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__ojlnk","isOpen":"modal_isOpen__Ww0As","coverWrapper":"modal_coverWrapper__3mZM9"};